import React from 'react';
import { Divider, Grid } from '@mui/material';
import { CardViewTextRow } from 'ui/viewComponents';
import { isSubscriptionPaymentReceivedAction } from '../models/Action';
import { ActionCardBase } from './ActionCardBase';
import { ActionCardModalComponentProps } from './ActionCardModalComponent';
import { getCurrencyString, titleize } from 'lib/helpers';
import { format, isValid } from 'date-fns';

const ActionCardSubscriptionPaymentReceived: React.FC<ActionCardModalComponentProps> = ({ action }) => {
    if (!isSubscriptionPaymentReceivedAction(action)) {
        return <ActionCardBase action={action} broken />;
    }

    const {
        subscriptionId,
        subscriptionSchemeId,
        currentBillingPeriodStart,
        currentBillingPeriodEnd,
        paymentMethod,
        subtotal,
        total,
        value
    } = action.metadata;

    const billingPeriodStartDate = new Date(currentBillingPeriodStart);
    const billingPeriodEndDate = new Date(currentBillingPeriodEnd);
    const billingPeriodRange =
        isValid(billingPeriodStartDate) && isValid(billingPeriodEndDate)
            ? `${format(billingPeriodStartDate, 'dd/MM/yyyy')} - ${format(
                  billingPeriodEndDate,
                  'dd/MM/yyyy'
              )}`
            : undefined;

    const paymentMethodString = paymentMethod?.lastFour
        ? `${paymentMethod.brand ? `${titleize(paymentMethod.brand)} ` : ''}**** **** **** ${
              paymentMethod.lastFour
          }`
        : undefined;

    return (
        <ActionCardBase action={action} showDate>
            <Grid container spacing={1}>
                <Grid item xs={6}>
                    <CardViewTextRow title="Subscription ID" value={subscriptionId} noTransform />
                </Grid>
                <Grid item xs={6}>
                    <CardViewTextRow title="Scheme ID" value={subscriptionSchemeId} noTransform />
                </Grid>

                <Grid item xs={12}>
                    <Divider />
                </Grid>

                {billingPeriodRange && (
                    <Grid item xs={paymentMethodString ? 6 : 12}>
                        <CardViewTextRow title="Billing Period" value={billingPeriodRange} />
                    </Grid>
                )}

                {paymentMethodString && (
                    <Grid item xs={billingPeriodRange ? 6 : 12}>
                        <CardViewTextRow title="Payment Method" value={paymentMethodString} />
                    </Grid>
                )}

                <Grid item xs={6}>
                    <CardViewTextRow title="Subtotal" value={getCurrencyString(subtotal, value.currency)} />
                </Grid>
                <Grid item xs={6}>
                    <CardViewTextRow title="Total" value={getCurrencyString(total, value.currency)} />
                </Grid>
            </Grid>
        </ActionCardBase>
    );
};

export default ActionCardSubscriptionPaymentReceived;
